import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
  const { auth } = useAuth();
  return auth.token ? <Navigate to="/" /> : children;
};

export default PublicRoute;
